"use client";

import { scrollBarStyle } from "@frontend/common/src/styles/mixin";
import { styled } from "styled-components";

export const FixedLayout = styled.div<{ $isOpen: boolean }>`
  position: absolute;
  bottom: ${({ $isOpen }) => ($isOpen ? "5.2rem" : "6.2rem")};
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: calc(100% + 4rem);
  min-width: 128rem;
  margin-left: -1.2rem;
  z-index: 50;
`;

export const BottomSheetWrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const BottomSheet = styled.div`
  position: relative;
  border-radius: 0.8rem 0.8rem 0rem 0rem;
  background: var(--Color-Common-Bg-Primary, #fff);

  border-bottom: 1px solid var(--Color-Common-Border-Tertiary, #e5e7eb);
  box-shadow: 0px -4px 6px 0px rgba(0, 0, 0, 0.08);

  display: flex;
  padding: 1.2rem 1.6rem 1.6rem 1.6rem;
  flex-direction: column;
  gap: var(--Spacing-12, 1.2rem);
  align-self: stretch;

  width: 100%;

  max-height: 23.8rem;
  overflow-y: auto;

  ${scrollBarStyle}
`;

const DefaultButton = styled.button`
  display: flex;
  height: 2.4rem;
  width: 13.3rem;
  justify-content: center;
  align-items: center;
  gap: var(--Spacing-2, 0.2rem);
  cursor: pointer;

  border-radius: var(--Border-Radius-4, 0.4rem);
`;

export const CloseButton = styled(DefaultButton)`
  background: var(--Color-Common-Bg-Interactive-Primary, #1baefe);
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.16),
    0px 0px 4px 0px rgba(0, 0, 0, 0.12);

  color: var(--Color-Common-Text-Interactive-Inverse, #fff);

  &:hover {
    background: var(--Color-Common-Bg-Interactive-Primary-Hovered, #0198e9);
  }

  &:active {
    background: var(--Color-Common-Bg-Interactive-Primary-Pressed, #017abc);
  }

  &:disabled {
    background: var(--Color-Common-Bg-Disabled, #cbd0d8);
    color: var(--Color-Common-Text-Disabled, #96a1b0);
    cursor: not-allowed;
  }
`;

export const OpenButton = styled(DefaultButton)`
  position: absolute;
  top: -1.5rem;
  left: 50%;
  transform: translateX(-50%);
  z-index: 100;

  background: var(--Color-Common-Bg-Interactive-Secondary, #fff);
  box-shadow: 0px -4px 6px 0px rgba(0, 0, 0, 0.08);

  color: var(--Color-Common-Text-Interactive-Primary, #0198e9);

  &:hover {
    color: var(--Color-Common-Text-Interactive-Primary-Hovered, #017abc);
    background: var(--Color-Common-Bg-Interactive-Secondary-Hovered, #f0f2f4);

    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.16),
      0px 0px 2px 0px rgba(0, 0, 0, 0.12);
  }

  &:active {
    color: var(--Color-Common-Text-Interactive-Primary-Hovered, #017abc);
    background: var(--Color-Common-Bg-Interactive-Secondary-Pressed, #e5e7eb);
  }
`;
